<script>
    import blockUI from './BlockUIService.js';
    import moment from 'moment';
    import DataService from './DataService.js';
    import CryptoJS from 'crypto-js';
    // النوافذ المنبثقة تُفتح من هنا مركزياً (انظر popup/confirmPopup/reasonPopup).
    import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                loginDetails: '',

                AcademicLevels: [],
                AcademicSpecializations: [],
                Subjects: [],
                Instructors: [],
                PaymentMethods: [],
                // Declared here so the "بند العملية" el-option list is reactive even
                // before any modal co-renders; GetAllFinancialsWithdrawing() fills it.
                FinancialsWithdrawing: [],

                Shapters: [],
                Courses: [],
                Users: [],
                Students: [],
                Distributors: [],

                Cities: [],


                //Municipalities: [],
                //Locations: [],

                //PaymentMethods: [],
                //Courses: [],
                //FromCourses: [],
                //ToCourses: [],


                //Distributors: [],

                /*Publeish*/
                ServerUrl: 'https://dashboard.evospace.ly',

                /*Local*/
                //ServerUrl: 'http://localhost:5000',
                Facebock: 'https://www.facebook.com/p/Traneem-100064940462078/?locale=ar_AR',
                Instagram: 'https://www.instagram.com/traneem5__/',
                TraneemPhone: '+218 94 457 81 48',
                TraneemEmail: 'info@traneem.ly',
                PlatFormPass: 'Traneem!@Platformv1',


                WebSiteName: 'رفيق',
                BuildFor: 'Rafiq',
                logoPath: '/assets/images/logos/Rafik Icon1.png',
                // Default avatar (SVG data-URI) — guarantees a clean fallback even when network/static asset is missing.
                CoverPath: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><circle cx='32' cy='32' r='32' fill='%230D6EFD'/><circle cx='32' cy='25' r='12' fill='white'/><path d='M10 60c0-12 10-20 22-20s22 8 22 20' fill='white'/></svg>",
                UserPath: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><circle cx='32' cy='32' r='32' fill='%230D6EFD'/><circle cx='32' cy='25' r='12' fill='white'/><path d='M10 60c0-12 10-20 22-20s22 8 22 20' fill='white'/></svg>",
                PdfPath: '/assets/img/icons/misc/pdf1.png',

            }
        },
        methods: {

            // ─────────────────────────────────────────────────────────────
            // النوافذ المنبثقة (Swal) — افتحها من هنا دائماً، لا بـ Swal.fire مباشرة.
            //
            // المشكلة التي يحلّها هذا: أغلب أزرار الإجراءات تعيش داخل قائمة
            // el-dropdown من Element UI، وهي تُغلق نفسها بحركة انتقال (~300ms)
            // وتُعيد التركيز للزر بعد الضغط. فتح نافذة SweetAlert في نفس اللحظة
            // يجعل الاثنين يتنازعان على التركيز و overflow الصفحة، فتظهر النافذة
            // متأخرة أو لا تظهر إطلاقاً. وإن كانت نافذة سابقة ما زالت تُغلق،
            // يتجاهل SweetAlert الطلب الجديد بصمت.
            //
            // الحل: أغلق أي نافذة مفتوحة، انتظر انتهاء دورة العرض (nextTick)
            // ثم إطاراً إضافياً حتى تكتمل حركة القائمة، وبعدها افتح.
            popup: function popup(options) {
                if (typeof Swal === 'undefined') return Promise.resolve({ isConfirmed: false });

                // نافذة ما زالت مفتوحة/تُغلق: أغلقها أولاً وإلا ضاع الطلب الجديد.
                if (Swal.isVisible && Swal.isVisible()) { Swal.close(); }

                return new Promise((resolve) => {
                    this.$nextTick(() => {
                        // إطاران: الأول ينهي إعادة الرسم، والثاني يترك القائمة تُغلق.
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                Swal.fire(Object.assign({
                                    heightAuto: false,   // يمنع Swal من العبث بارتفاع body داخل RTL
                                    buttonsStyling: false,
                                    customClass: {
                                        confirmButton: 'btn btn-primary',
                                        cancelButton: 'btn btn-light ms-2',
                                        denyButton: 'btn btn-danger ms-2'
                                    }
                                }, options)).then(resolve);
                            });
                        });
                    });
                });
            },

            // تأكيد بسيط: نعم/إلغاء. يرجّع true فقط عند التأكيد.
            confirmPopup: function confirmPopup(options) {
                return this.popup(Object.assign({
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'نعم',
                    cancelButtonText: 'إلغاء'
                }, options)).then((r) => !!(r && r.isConfirmed));
            },

            // تأكيد يطلب سبباً مكتوباً. يرجّع نص السبب، أو null عند الإلغاء.
            // السبب إلزامي: إجراء يُبلَّغ به المستخدم النهائي بلا سبب هو إجراء
            // لا يستطيع أحد شرحه لاحقاً — لا للسائق ولا للدعم.
            reasonPopup: function reasonPopup(options) {
                var opts = options || {};
                return this.popup({
                    title: opts.title,
                    html: opts.html,
                    icon: opts.icon || 'warning',
                    input: 'textarea',
                    inputLabel: opts.inputLabel || 'السبب (إلزامي)',
                    inputPlaceholder: opts.inputPlaceholder || 'اكتب السبب — سيظهر لصاحب الحساب',
                    inputAttributes: { 'aria-label': opts.inputLabel || 'السبب' },
                    showCancelButton: true,
                    confirmButtonText: opts.confirmButtonText || 'تأكيد',
                    cancelButtonText: 'إلغاء',
                    inputValidator: function (value) {
                        if (!value || !value.trim()) return 'السبب مطلوب';
                        if (value.trim().length < 3) return 'اكتب سبباً مفهوماً';
                        return null;
                    }
                }).then((r) => (r && r.isConfirmed && r.value ? r.value.trim() : null));
            },

            encrypt: function encrypt(data, SECRET_KEY) {
                var dataSet = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY);
                dataSet = dataSet.toString();
                return dataSet;
            },
            decrypt: function decrypt(data, SECRET_KEY) {
                data = CryptoJS.AES.decrypt(data, SECRET_KEY);
                data = JSON.parse(data.toString(CryptoJS.enc.Utf8));
                return data;
            },

            ClearForm(ruleForm) {
                for (const key in ruleForm) {
                    const current = ruleForm[key];
                    if (Array.isArray(current)) {
                        ruleForm[key] = []; // keep arrays as arrays
                    } else if (typeof current === 'number') {
                        ruleForm[key] = null; // numbers reset to null, not ''
                    } else {
                        ruleForm[key] = ''; // strings/other reset to empty string
                    }
                }
            },

            async CheckLoginStatus() {
                // 1) Local copy first — if we don't even have a stored user,
                // there is no session to validate. Skip the API call entirely
                // and send the user back to login cleanly.
                const raw = localStorage.getItem('currentUser-client');
                if (!raw) {
                    this.logout();
                    return null;
                }
                let details = null;
                try {
                    details = JSON.parse(this.decrypt(raw, this.PlatFormPass));
                } catch (e) {
                    // Stored blob is corrupt — wipe and bail.
                    console.warn('[CheckLoginStatus] decrypt failed:', e && e.message);
                    this.logout();
                    return null;
                }
                // 2) Server-side cookie validation. A network blip should NOT
                // log the user out — only an explicit `false` from the server
                // (which means the cookie is gone or expired) should.
                try {
                    const res = await DataService.IsLoggedin();
                    if (res && res.data === false) {
                        this.logout();
                        return null;
                    }
                } catch (e) {
                    // Network error / 5xx: keep the local session so the user
                    // is not forcibly redirected to login on transient failures.
                    console.warn('[CheckLoginStatus] IsLoggedin check failed (kept local session):', e && e.message);
                }
                this.loginDetails = details;
                return details;
            },

            // Use this instead of this.logout() when a page is opened by a user
            // whose role lacks permission. Sends them to their proper landing
            // page WITHOUT destroying their session.
            redirectToProperHome() {
                const ut = this.loginDetails ? this.loginDetails.userType : null;
                let target = '/login';
                if (ut === 1 || ut === 2 || ut === 3) target = '/Home';
                else if (ut === 40 || ut === 41) target = '/Schools';
                else if (ut === 50) target = '/VoucherCardsDashboard';
                if (this.$router) {
                    this.$router.replace({ path: target }).catch(function () { /* duplicate */ });
                } else {
                    window.location.assign(target);
                }
            },

            // Guard helper: returns true if userType is allowed; otherwise redirects
            // to that user's proper home page and returns false. Replaces the
            // pattern: if (userType != 1) this.logout()
            requireUserType(allowedTypes) {
                if (!this.loginDetails) {
                    this.logout();
                    return false;
                }
                const allowed = Array.isArray(allowedTypes) ? allowedTypes : [allowedTypes];
                if (!allowed.includes(this.loginDetails.userType)) {
                    this.redirectToProperHome();
                    return false;
                }
                return true;
            },

            getSchoolId() {
                const id = localStorage.getItem('schoolId');
                return id ? Number(id) : null;
            },

            getSchoolName() {
                return localStorage.getItem('schoolName') || '';
            },
            isSchoolAdmin() {
                const ut = this.loginDetails ? this.loginDetails.userType : null;
                return ut === 40 || ut === 41;
            },
            isSchoolOwner() {
                return this.loginDetails && this.loginDetails.userType === 40;
            },
            isSchoolEmployee() {
                return this.loginDetails && this.loginDetails.userType === 41;
            },
            /** JS mirror of Common.PhoneUtils.Normalize. */
            normalizePhone(input) {
                if (!input) return '';
                const digits = String(input).replace(/\D/g, '');
                let n = digits;
                if (n.startsWith('00218')) n = n.slice(5);
                else if (n.startsWith('218')) n = n.slice(3);
                else if (n.startsWith('0')) n = n.slice(1);
                if (n.length !== 9 || n[0] !== '9') return '';
                return '+218' + n;
            },

            async logout() {
                try {
                    await this.$http.Logout();
                } catch (e) {
                    /* ignore network / 401 */
                } finally {
                    localStorage.removeItem('currentUser-client');
                    localStorage.clear();
                    document.cookie.split(';').forEach(function (c) {
                        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
                    });
                }
                if (this.$router) {
                    this.$router.replace({ path: '/login' }).catch(function () { /* duplicate navigation */ });
                } else {
                    window.location.assign('/login');
                }
            },


            formatNumber(num) {
                if (num) {
                    if (num <= 0) {
                        return 0;
                    } else {
                        return new Intl.NumberFormat('en-US').format(num); // Format the number
                    }
                } else {
                    return 0;
                }
            },

            formatNumberFloat(num) {
                if (num !== null && num !== undefined) {
                    if (num <= 0) {
                        return 0; // Return 0 for non-positive numbers
                    } else if (Number.isInteger(num)) {
                        return num.toString(); // Return integer as a string without decimals
                    } else {
                        return num.toFixed(2); // Format double to two decimal places
                    }
                } else {
                    return 0; // Return 0 if num is null or undefined
                }
            },

            moment(date) {
                if (date === null) {
                    return "------";
                }
                // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                return moment(date).format('DD/MM/YYYY');
            },

            momentTime(date) {
                if (date === null) {
                    return "------";
                }
                // Arabic meridiem (ص/م) instead of the Latin am/pm so RTL
                // dashboards render a consistent Arabic date-time.
                const m = moment(date);
                const meridiem = m.format('A') === 'AM' ? 'ص' : 'م';
                return m.format('DD/MM/YYYY ||  h:mm') + ' ' + meridiem;
            },

            ChangeDate(date) {
                if (date === null) {
                    return "فارغ";
                }
                return moment(date).format("YYYY-MM-DD");
            },

            ChangeDateTimeToISO(datetime) {
                if (!datetime) {
                    return "";
                }
                return moment(datetime).format("YYYY-MM-DDTHH:mm:ss");
            },

            GetToday() {
                return moment().format("YYYY-MM-DD");
            },





            //Get Dictionaries
            async GetAllCities() {
                this.Cities = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllCities();
                    this.Cities = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },


            async GetAllAcademicLevels() {
                this.AcademicLevels = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllAcademicLevels();
                    this.AcademicLevels = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllAcademicSpecializations(Id) {
                this.AcademicSpecializations = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllAcademicSpecializations(Id);
                    this.AcademicSpecializations = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllSubjects() {
                this.Subjects = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllSubjects();
                    this.Subjects = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllInstructors() {
                this.Instructors = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllInstructors();
                    this.Instructors = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllPaymentMethods() {
                this.PaymentMethods = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllPaymentMethods();
                    this.PaymentMethods = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },


            async GetAllFinancialsWithdrawing() {
                this.FinancialsWithdrawing = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllFinancialsWithdrawing();
                    this.FinancialsWithdrawing = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllShapters(Id) {
                this.Shapters = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllShapters(Id);
                    this.Shapters = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },


            async GetAllCourses(SubjectId, AcademicSpecializationId) {
                this.Courses = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllCoursesBySubjectSpecialization(SubjectId, AcademicSpecializationId);
                    this.Courses = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },



            async GetAllUsers() {
                this.Users = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllUsers();
                    this.Users = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },


            async GetAllDistributors() {
                this.Distributors = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllDistributors();
                    this.Distributors = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },

            async GetAllStudents() {
                this.Students = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetAllStudents();
                    this.Students = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },







        }
    }
</script>
